import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {Alert} from '@mui/material';
import {Cancel} from '@mui/icons-material';
import {Snackbar } from '@mui/material';
import styled from "styled-components";
import { filter, find, get } from "lodash";
import { handleGetDifferentiationLesson } from "store/DifferentiationLesson/thunks";
import { updateUI } from "store/UI/actions";
import { useAllBook } from "store/books/selectors";
import { useCurrentUser, useUserProfileConfig } from "store/users/selectors";
import { useDifferentiationLesson } from "store/DifferentiationLesson/selectors";
import "../Differentiation/index.css";
import CreateDifferentiationModal from "./CreateDifferentiationModal";
import { cleanHTMLString } from "utils/methods/textMethod";
import { getAwsAuthToken } from "utils/lib/authHelper";
import sysConf from "config";
import usePopUpAtOnce from "components/hooks/usePopUpAtOnce";
import { Dropdown } from "antd";
import * as Sentry from '@sentry/react';
import SentryWrap from 'components/Sentry';
import useBadWords from "components/hooks/words/badWords";
import { useAlert } from "components/UI/alertSakeBar/alertProvider";

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Components ---------------------

//  -- Constants ----------------------

// Super-lession css
const ModalSuperPlane = styled.div`
  align-items: center;
  background-color: #000f4c;
  border-radius: 3px;
  display: inline-flex;
  flex-direction: column;
  left: 50%;
  max-width: 320px !important;
  padding: 24px 28px;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  @media screen and (min-width: 700px) and (max-width:768px){
      left:15vw;
  }
`;
const CustomMenuItem2 = styled.div`
  background: rgb(16,44,110);
  color: white;
  padding: 7px 20px;
  border-radius: 5px;
  margin: 2px;
  text-align: center;
  cursor: pointer;
  
  &:hover {
    background: rgb(16,44,110);
  }
`;
// end Super-lession css

const useStyles = makeStyles({
  disabledButton: {
    color: "white", // Text color when disabled
    "&.Mui-disabled": {
      color: "white", // Ensures the color remains white even if the button is disabled
    },
  },
});
const DifferentiationComponent = ({ onLessonAi, filterMyData, onReplacement  ,setAlertSakeBar ,isAiPermissionEnabled,updatePopUpAtOnce}) => {

  const handleMenuClick = async ({ key }) => {
    if(!isAiPermissionEnabled){
      setAlertSakeBar({
        open: true,
        message: 'Please enable AI permission to generate differentiation.',
        severity: 'error',
      });
      return;
    }
    updatePopUpAtOnce(true);
    if (filterMyData?.id) {
      onReplacement({ language: key });
    } else {
      await onLessonAi({ language: key });
    }
  };

  const menuProps = {
    items: [
      { key: "spanish", label: <CustomMenuItem2>Spanish</CustomMenuItem2> },
      { key: "english", label: <CustomMenuItem2 >English</CustomMenuItem2> },
      // { key: "french", label: <CustomMenuItem2 >French</CustomMenuItem2> },
    ],
    onClick: handleMenuClick
  }

  return (
    <Dropdown menu={menuProps} overlayClassName="notificationPopOver" trigger={['click']}>
      <Button>
        New differentiation
      </Button>
    </Dropdown>
  );
};

const Differentiation = ({
  superLessonData,
  bookId,
  pageId,
  viewLesson,
  showModal,
  data,
  onLessonOpen = () => null,
  onDifferentiationOpen = () => null,
  onViewShowData = () => null,
  superLessonOpen,
  from,
  setOpenDiffernationToolModal,
  setToolsDropdown,
  openDiffernationToolModal,
  setViewStreamLesson,
  setIsStream
}) => {
  const classes = useStyles();
  const currentUser = useCurrentUser();
  const superLesson = useDifferentiationLesson();
  const [alertSakeBar, setAlertSakeBar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [superLession, setSuperLession] = useState(false);
  const [showReplacementMessage, setShowReplacementMessage] = useState(false);
  const [createLesson, setCreateLesson] = useState(false);
  const filterLesson = find(superLesson, (data) => data?.userId === currentUser?.id && data?.access_by?.includes(currentUser?.id)) || {};
  const filterShareLesson = filter(superLesson, (data) => data?.userId !== currentUser?.id && data?.access_by?.includes(currentUser?.id)) || [];
  const [filterMyData, setFilterMyData] = useState(filterLesson);
  const [filterSharedLesson, setFilterSharedLesson] = useState(filterShareLesson);
  const [isMobile, setIsMobile] = useState(window.innerWidth);
  const selected_language = useRef(null);
  const { isAiPermissionEnabled } = useUserProfileConfig();
  // const booksAllList = useAllBook()
  const isCanvasUser  = !!get(currentUser,"canvas_id")
  const {updatePopUpAtOnce} = usePopUpAtOnce();
  const {getTextFromHtml} = useBadWords();
  const showAlert = useAlert();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {
    setFilterSharedLesson(filterShareLesson);
    setFilterMyData(filterLesson);
  }, [superLesson])

  useEffect(() => {
    onFetchLesson();
  }, [pageId, bookId]);

  const onFetchLesson = async () => {
    const data = {
      bookId: bookId,
      pageId: pageId,
      userId: currentUser.id,
    };
    await dispatch(handleGetDifferentiationLesson(data));
  };

  const closeAlert = () => {
    setAlertSakeBar({ open: false, message: "", severity: "success" });
  };

  async function streamData(inputData, onChunk, LIMIT = 0) {
    try {
      const token = await getAwsAuthToken();
      const response = await fetch(`${sysConf.apiGateway.AI_BASE_NODE_URL}/DifferentiationStream/differentiation-stream`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          "x-auth-source": sysConf.isDev ? "test" : "prod",
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(inputData),
      });

      if (!response.ok || !response.body) {
        throw new Error('Stream failed to start');
      }
    
      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');
      let buffer = '';
      let fullTextAccumulator = '';
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const text = decoder.decode(value);
        const lines = text.split('\n').filter(Boolean);

        for (const line of lines) {
          const payload = line.replace('data: ', '').trim();
          if (line.startsWith('data:') && line.replace('data: ', '').trim() === '[DONE]') {
            const getText = getTextFromHtml(fullTextAccumulator);
            if(getText.toLowerCase().includes("i'm sorry") && LIMIT < 3){
              showAlert("I'm sorry, I can't assist with that request.AI is generating again.. please wait","error");
              await streamData(inputData, onChunk, LIMIT + 1);
              return;
            }
            onFetchLesson();
            setViewStreamLesson('');
            setAlertSakeBar({open: true, message: "Created successfully", severity: "success" });
            setCreateLesson(false);
            setIsStream(false);
            return; // Exit the function
          }
          if (payload === '[ERROR]') {
            console.error('Stream returned an error signal.');
            setAlertSakeBar({ open: true, message: 'Failed to create lesson. Please try again.', severity: 'error' });
            setCreateLesson(false);
            setViewStreamLesson('');
            setIsStream(false);
            return;
          }
          fullTextAccumulator += line.replace('data: ', '');
          onChunk(cleanHTMLString(fullTextAccumulator));
        }
      }
    } catch (error) {
      console.error('Stream error:', error);
      setAlertSakeBar({
        open: true,
        message: 'Failed to create lesson. Please try again.',
        severity: 'error',
      });
      setCreateLesson(false);
      Sentry.captureException(`Error in differentiation lesson stream: ${error}`);
    }
  }

  const onLessonAi = async (differentiation_data) => {
    if (!isAiPermissionEnabled) {
      setAlertSakeBar({
        open: true,
        message: 'Please enable AI permission to generate differentiation.',
        severity: 'error',
      });
      return;
    }
    const { limit, ...superLessonPayload } = filterMyData;
    const data = {
      ...superLessonPayload,
      bookId,
      pageId,
      from_page: superLessonData.from,
      to_page: superLessonData.to,
      userId: currentUser.id,
      differentiation_data,
      access_by: [currentUser.id],
      mode: import.meta.env.VITE_APP_STAGE?.trim() === "prod" ? "prod" : "dev",
      language: selected_language.current || "spanish",
    };
    setCreateLesson(true);
    setSuperLession(false);
    const SuperLessonData = {};
    let fullHTML = "";

    setIsStream(true);
    await streamData(data, async (chunk) => {
      fullHTML += chunk;
      setCreateLesson(false);
      await dispatch(updateUI({openDiffModal: true}));
      onLessonOpen();
        // setLoader(false);
        onViewShowData(chunk);
    });
  };

  useEffect(()=>{
    if (!viewLesson && openDiffernationToolModal) {
      setToolsDropdown(false);
      setOpenDiffernationToolModal(false);
      setSuperLession(!superLession);
      setFilterMyData(filterLesson);
      setFilterSharedLesson(filterShareLesson);
      onFetchLesson()
      setShowReplacementMessage(false)
      onDifferentiationOpen(!superLession)
    }
  },[openDiffernationToolModal])

  const handleSuperLesson = () => {
    if (superLessonOpen) {
      setAlertSakeBar({
        open: true,
        message:
          "Please close the SuperLesson, to open the Differentiation",
        severity: "error",
      });
    } else {
      if (!viewLesson) {
        setSuperLession(!superLession);
        setFilterMyData(filterLesson);
        setFilterSharedLesson(filterShareLesson);
        onFetchLesson()
        setShowReplacementMessage(false)
        onDifferentiationOpen(!superLession)
      }
    }
  };

  const handleMyLession = async () => {
    // setCreateLesson(true);
    // setSuperLession(false);
    setShowReplacementMessage(false);
    await onLessonAi({});
  };


  return (
    <SentryWrap>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertSakeBar.open}
        autoHideDuration={3000}
        onClose={closeAlert}
      >
        <Alert
          onClose={() => {
            setAlertSakeBar({ open: false, message: "" });
          }}
          severity={alertSakeBar.severity}
        >
          <strong>ALERT:</strong> {alertSakeBar.message}
        </Alert>
      </Snackbar>
      <>
        {superLession && (
          <div
            // className="superLessionModal"
            className="superLessionModal"
          // style={{ height: '100%', width: '100%', backgroundColor: "transparent" }}
          >
            <ModalSuperPlane className={`DifferentiationLessionContents ${superLession ? 'differentiation-modal-container' : ''}`}>
              <span onClick={async () => {
                updatePopUpAtOnce(false)
                setSuperLession(false);
                onDifferentiationOpen(false);
                setShowReplacementMessage(false)
                await dispatch(updateUI({openDiffModal: false}))
              }}>
                <Cancel
                  style={{
                    position: "absolute",
                    right: -4,
                    top: -10,
                    fontSize: 22,
                    color: "red",
                    background: "white",
                    borderRadius: 20,
                    cursor: "pointer",
                  }}
                />
              </span>
              <Button
                className={classes.disabledButton}
                onClick={async () => {
                  updatePopUpAtOnce(true);
                  onLessonOpen("shared");
                  setSuperLession(false);
                  await dispatch(updateUI({openDiffModal: true}));
                }}
                disabled={filterSharedLesson?.length === 0}
                style={{ opacity: filterSharedLesson?.length === 0 ? 0.6 : 1 }}
              >
                See shared differentiations
              </Button>
              <Button
                className={classes.disabledButton}
                onClick={async () => {
                  updatePopUpAtOnce(true);
                  onLessonOpen();
                  setSuperLession(false);
                  await dispatch(updateUI({openDiffModal: true}));
                  setIsStream(false);
                }}
                disabled={!filterMyData ||
                  !filterMyData.id ||
                  (typeof filterMyData === 'object' && Object.keys(filterMyData).length === 0)}
                style={{
                  opacity: !filterMyData ||
                    !filterMyData.id ||
                    (typeof filterMyData === 'object' && Object.keys(filterMyData).length === 0) ? 0.6 : 1
                }}
              >
                See saved differentiations
              </Button>
              <DifferentiationComponent
                updatePopUpAtOnce={updatePopUpAtOnce}
                filterMyData={filterMyData}
                onLessonAi={({ language }) => {
                  selected_language.current = language;
                  onLessonAi({});
                }}
                onReplacement={({ language }) => {
                  selected_language.current = language;
                  setShowReplacementMessage(true);
                }}
                setAlertSakeBar={setAlertSakeBar}
                isAiPermissionEnabled={isAiPermissionEnabled}
              />
              {/* <Button
                onClick={async () => {
                  if (filterMyData?.id) {
                    setShowReplacementMessage(true);
                  } else {
                    await onLessonAi({});
                  }
                }}
              >
                New differentiation
              </Button> */}
            </ModalSuperPlane>
          </div>
        )}
        {showReplacementMessage && filterMyData?.id && (
          <div className="allCreateLession">
            <div 
            // className="creatLessionSection"
            className="creatLessionSection"
            >
              <p>
                By creating a new lesson, your saved lesson will be replaced
              </p>
              <div className="createBtnSection">
                <Button onClick={handleMyLession}>I agree</Button>
                <Button onClick={async () => {
                  updatePopUpAtOnce(false)
                   setShowReplacementMessage(false)
                    await dispatch(updateUI({openDiffModal: false}));
                }}>
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        )}
        {showModal && (
          <CreateDifferentiationModal open={createLesson} loader={loader} from={from} isCanvasUser={isCanvasUser} />
        )}
      </>
    </SentryWrap>
  );
};

export default Differentiation;